module.exports = __webpack_public_path__ + "img/sbp.8749d850.png";